export default {
  "hierarchy": {
    "rsrcFilterByCreatedAt": [
      "dateTimeRangePicker-rsrcFilterByCreatedAt"
    ]
  },
  "props": {
    "default": {
      "data-error": true,
      "dateFormat": "M/d",
      "rangeChangeType": null,
      "timeFormat": "h:mm a"
    },
    "rsrcFilterByCreatedAt": {
      "data-error": true,
      "dateFormat": "M/d",
      "rangeChangeType": null,
      "timeFormat": "h:mm a"
    }
  }
}